import React, { FC } from "react";
import styled from "styled-components";
import { PropsWithPropStyling, propStyling, tombac } from "tombac";

export const TrialBadge: FC<PropsWithPropStyling> = (props) => (
  <Container {...props}>Free trial</Container>
);

const Container = styled.span`
  all: initial;

  align-items: center;
  background-color: ${tombac.color("alert", 200)};
  border-radius: ${tombac.unit(5)};
  box-sizing: border-box;
  cursor: inherit;
  display: flex;
  height: ${tombac.unit(20)};
  padding: 0.1em ${tombac.space(0.5)} 0;
  text-transform: uppercase;
  white-space: nowrap;

  ${tombac.altText({
    color: tombac.color("alert", 500),
    fontSize: 10,
    fontWeight: 600,
  })}

  ${propStyling}
`;
